/**
 * Los tokens de la sesión en el navegador: dónde se guardan y dónde se borran.
 *
 * Un solo sitio escribe `access_token` / `refresh_token` (FE-11). Antes lo
 * hacían tres: el inicio de sesión, el registro y —por separado— cada una de
 * las DOS implementaciones del refresco. Con la pestaña en segundo plano
 * podían pisarse el token entre ellas, y para saber quién había escrito el
 * último había que mirar en cuatro ficheros.
 *
 * Al cerrar sesión solo se borraban los tokens: el historial de informes, las
 * notificaciones y los datos del usuario (con nombres de equipos y hallazgos
 * del cliente) se quedaban en localStorage para el siguiente que usara el
 * equipo (auditoría vibe 2026-10-07, FE-20). Las preferencias de interfaz
 * (tema, barra lateral, tour visto) sí se conservan: no son datos del cliente.
 */

const SESSION_LOCAL_KEYS = [
  'access_token',
  'refresh_token',
  'user',
  'notifications',
  'reportHistory',
  'agentCommandHistory',
  'commandPalette_recentSearches',
];

const SESSION_TAB_KEYS = ['isAuthenticated', 'selectedTenant'];

/**
 * Guarda el par de tokens que devuelve el inicio de sesión o el registro.
 * `refreshToken` es opcional: hay respuestas que solo renuevan el de acceso.
 */
export const storeTokens = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem('access_token', accessToken);
  if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
};

/** Lee el token de acceso vigente (lo usa el interceptor de petición). */
export const getAccessToken = () => localStorage.getItem('access_token');

/** Lee el token de refresco vigente (lo usa el único camino de refresco). */
export const getRefreshToken = () => localStorage.getItem('refresh_token');

export const clearSessionData = () => {
  try {
    SESSION_LOCAL_KEYS.forEach((key) => localStorage.removeItem(key));
    SESSION_TAB_KEYS.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // silencio-ok: almacenamiento bloqueado (navegación privada), no hay nada que borrar
  }
};
